'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rmcPullToRefresh = require('rmc-pull-to-refresh');

var _rmcPullToRefresh2 = _interopRequireDefault(_rmcPullToRefresh);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PullToRefresh = function (_React$Component) {
    (0, _inherits3['default'])(PullToRefresh, _React$Component);

    function PullToRefresh() {
        (0, _classCallCheck3['default'])(this, PullToRefresh);
        return (0, _possibleConstructorReturn3['default'])(this, (PullToRefresh.__proto__ || Object.getPrototypeOf(PullToRefresh)).apply(this, arguments));
    }

    (0, _createClass3['default'])(PullToRefresh, [{
        key: 'render',
        value: function render() {
            var ind = (0, _extends3['default'])({ activate: '松开立即刷新', deactivate: '下拉可以刷新', release: _react2['default'].createElement(_icon2['default'], { type: 'loading' }), finish: '完成刷新' }, this.props.indicator);
            return _react2['default'].createElement(_rmcPullToRefresh2['default'], (0, _extends3['default'])({}, this.props, { indicator: ind }));
        }
    }]);
    return PullToRefresh;
}(_react2['default'].Component);

exports['default'] = PullToRefresh;

PullToRefresh.defaultProps = {
    prefixCls: 'am-pull-to-refresh'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/pull-to-refresh/index.js
// module id = 271
// module chunks = 0